export enum EmailTemplateTrigger {
  BOOKING_CONFIRMED = "BOOKING_CONFIRMED",
  BOOKING_CANCELED = "BOOKING_CANCELED",
  CHECKIN_COMPLETED = "CHECKIN_COMPLETED",
  CHECKIN_REMINDER = "CHECKIN_REMINDER",
  CHECKOUT_COMPLETED = "CHECKOUT_COMPLETED",
  CHECKOUT_REMINDER = "CHECKOUT_REMINDER",
  POST_CHECKOUT_FEEDBACK = "POST_CHECKOUT_FEEDBACK",
}

export const EMAIL_TEMPLATE_TRIGGER_LABELS: Record<
  EmailTemplateTrigger,
  string
> = {
  [EmailTemplateTrigger.BOOKING_CONFIRMED]: "Booking confirmation",
  [EmailTemplateTrigger.BOOKING_CANCELED]: "Booking canceled",
  [EmailTemplateTrigger.CHECKIN_COMPLETED]: "Check-in completed",
  [EmailTemplateTrigger.CHECKIN_REMINDER]: "Pre-check-in reminder",
  [EmailTemplateTrigger.CHECKOUT_COMPLETED]: "Check-out completed",
  [EmailTemplateTrigger.CHECKOUT_REMINDER]: "Pre-check-out reminder",
  [EmailTemplateTrigger.POST_CHECKOUT_FEEDBACK]: "Post check-out feedback",
};

export const EMAIL_TEMPLATE_TRIGGER_DESCRIPTIONS: Record<
  EmailTemplateTrigger,
  string
> = {
  [EmailTemplateTrigger.BOOKING_CONFIRMED]:
    "Sent after a booking is confirmed.",
  [EmailTemplateTrigger.BOOKING_CANCELED]: "Sent when a booking is canceled.",
  [EmailTemplateTrigger.CHECKIN_COMPLETED]:
    "Sent after the guest completes online check-in.",
  [EmailTemplateTrigger.CHECKIN_REMINDER]:
    "Sent before arrival with the online check-in link.",
  [EmailTemplateTrigger.CHECKOUT_COMPLETED]:
    "Sent after the guest completes online check-out.",
  [EmailTemplateTrigger.CHECKOUT_REMINDER]:
    "Sent before departure with the online check-out link.",
  [EmailTemplateTrigger.POST_CHECKOUT_FEEDBACK]:
    "Sent after departure with the feedback link.",
};

export interface HotelEmailTemplate {
  id: string | null;
  hotelId: string;
  trigger: EmailTemplateTrigger;
  title: string;
  subject: string;
  htmlContent: string;
  plainContent: string | null;
  enabled: boolean;
  heroPhotoId: string | null;
  isCustom: boolean;
  variables: string[];
  createdAt: string | null;
  updatedAt: string | null;
}

export interface UpsertHotelEmailTemplatePayload {
  title?: string;
  subject?: string;
  htmlContent?: string;
  plainContent?: string | null;
  enabled?: boolean;
  heroPhotoId?: string | null;
}

export interface PreviewHotelEmailTemplatePayload {
  trigger: EmailTemplateTrigger;
  subject: string;
  htmlContent: string;
  plainContent?: string | null;
  heroPhotoId?: string | null;
  preview?: {
    sampleData?: Record<string, unknown>;
  };
}

export interface RenderedHotelEmailTemplate {
  subject: string;
  html: string;
  text: string;
}
